import React from 'react';
import { cn } from '@/lib/utils';
import { BadgeCheck, Clock, XCircle, PauseCircle } from 'lucide-react';

const STATUS_CONFIG = {
  approved: {
    label: 'Approved',
    icon: BadgeCheck,
    className: 'bg-emerald-50 border-emerald-200 text-emerald-700',
    body: "You're live! You can accept booking requests.",
  },
  pending: {
    label: 'Pending',
    icon: Clock,
    className: 'bg-amber-50 border-amber-200 text-amber-700',
    body: 'Your profile is pending admin approval. You can still set up services and upload documents.',
  },
  rejected: {
    label: 'Rejected',
    icon: XCircle,
    className: 'bg-rose-50 border-rose-200 text-rose-700',
    body: 'Your application was rejected. Please contact support for next steps.',
  },
  suspended: {
    label: 'Suspended',
    icon: PauseCircle,
    className: 'bg-slate-100 border-slate-200 text-slate-700',
    body: 'Your account is suspended. Bookings are paused until reactivated.',
  },
};

export default function PartnerStatusBanner({ status, businessName, compact = false }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = cfg.icon;
  if (compact) {
    return (
      <span
        data-testid={`partner-status-badge-${status}`}
        className={cn('inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium', cfg.className)}
      >
        <Icon className="h-3 w-3" /> {cfg.label}
      </span>
    );
  }
  return (
    <div
      data-testid={`partner-status-banner-${status}`}
      className={cn('rounded-xl border p-4 flex items-start gap-3', cfg.className)}
    >
      <div className="shrink-0 mt-0.5"><Icon className="h-5 w-5" /></div>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-sm font-semibold">{businessName || 'Your business'}</p>
          <span className="text-[10px] uppercase tracking-wider opacity-75">{cfg.label}</span>
        </div>
        <p className="text-xs mt-0.5 opacity-90">{cfg.body}</p>
      </div>
    </div>
  );
}
